import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class NotFoundResolver  {
  resolve(): string {
    return 'Error Handler Resolved';
  }
}